import * as React from 'react';
import { cn } from '@/lib/utils';

interface TooltipProps {
    children: React.ReactElement;
    content: string;
    side?: 'top' | 'bottom' | 'left' | 'right';
}

export function Tooltip({ children, content, side = 'top' }: TooltipProps) {
    const [isVisible, setIsVisible] = React.useState(false);

    const sideClasses = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    };

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div
                    className={cn(
                        'absolute z-[9999] px-3 py-1.5 text-sm text-white bg-black/90 backdrop-blur-sm rounded-lg whitespace-nowrap pointer-events-none shadow-xl',
                        sideClasses[side]
                    )}
                >
                    {content}
                </div>
            )}
        </div>
    );
}
